<div class="gridContainer">

    <h1>Bürgschaften</h1>

    <div class="gridContainer actionGrid">
    @if (vertraegeList() && vertraegeList().length > 0) {
        <div class="row">
            <div class="cell grid-20">
                <div class="form-select">
                    <select [(ngModel)]="selectedVsnr"
                            [disabled]="$safeNavigationMigration(vertraegeList()?.length) <= 1"
                            (change)="notifyChangedVsnr()"
                            aria-label="Vertrag">
                        @if (vertraegeList().length > 1) {
                            <option [value]="emptyVertrag">Vertrag</option>
                        }
                        @for (vertrag of vertraegeList(); track vertrag) {
                            <option
                                [value]="vertrag.vertragHandle.vsnrNumerisch">{{ vertrag.vertragHandle.vsnrFormatiert }}
                            </option>
                        }
                    </select>
                </div>
            </div>
            <div class="cell grid-20">
                <div class="form-select">
                    <select [(ngModel)]="selectedGeschaeftsjahr"
                            [disabled]="$safeNavigationMigration(geschaeftsjahreList()?.length) <= 1"
                            (change)="notifyChangedYear()"
                            aria-label="Geschäftsjahr">
                        <option [value]="emptyGeschaeftsjahr">Jahr</option>
                        @for (year of geschaeftsjahreList(); track year) {
                            <option [value]="year">{{ year }}</option>
                        }
                    </select>
                </div>
            </div>
            <div class="cell grid-60">
                <div class="actionsContainer">
                    <button class="btn-white-orange" (click)="goToObligo()">
                        <span class="btn-ico-liste"></span> <span class="btn-text">Obligoliste anfordern</span>
                    </button>
                    @if (canAddBs()) {
                        <button class="btn-white-orange" (click)="goToAddBuergscheinAction()">
                            <span class="btn-ico-neu"></span> <span class="btn-text">Bürgschaft beantragen</span>
                        </button>
                    }
                </div>
            </div>
        </div>

        @if (!visibleBuergscheine() && (!selectedVsnr() || !selectedGeschaeftsjahr())) {
            <p class="hinweis">Bitte wählen Sie zur Anzeige zunächst einen Vertrag und ein Geschäftsjahr aus.</p>
        }
    } @else {
        <p>Es wurden keine Verträge gefunden.</p>
    }
    </div>

    @if (visibleBuergscheine()) {
        <div>
            <pagination [numItems]="visibleBuergscheine().length"
                        [current]="currentOffset()"
                        (goToPageEvent)="pagerAction($event)"></pagination>
            <elem-table [tableData]="visibleBuergscheine()"
                        [tableMeta]="buergscheinMetaData"
                        [actionFn]="goToBuergscheinAction"
                        [targetParam]="'buergscheinId'"
                        [searchAction]="searchBuergschein"
                        [detailsClass]="'openDetails'"
                        [detailsTitle]="'Zur Detailansicht'"
                        [currentOffset]="currentOffset()"
                        [lineHasChild]="true"
                        (goToPageEvent)="pagerAction($event)"></elem-table>
            <pagination [numItems]="visibleBuergscheine().length"
                        [current]="currentOffset()"
                        (goToPageEvent)="pagerAction($event)"></pagination>
        </div>
    }

</div>
